import { from } from "rxjs";

export class DistributionNumber {
    distributionNumberId: number;
    auctionClusterId: number;
    buyerId: number;
    buyerDisplayName: string;
    masterDataListRowId: number;
    distributionNumberRangeType: number;
    value: number;
  }

  export class DistributionNumberSuggestion {
    from: number;
    till: number;
    value: number;
  }